class GrowTrendstudie { 
	setCategoryFilter(el) { 
		document.body.dataset.trendfilter = el.dataset.filter
		// remove active class from all sibling buttons
		el.parentNode.querySelectorAll('button').forEach(button => {
			button.classList.remove('active')
		})
		// add active class to clicked button
		el.classList.add('active')

	}
}

const growTrendstudie = new GrowTrendstudie()